export default __webpack_public_path__ + "locales/si/ChangePhoneDialog.json?hash=9a751be6c62976f418358352cc7c7798";